module.exports = __webpack_public_path__ + "img/pmsm1_.4582ac46.png";